import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-catalog-crud-modal',
  templateUrl: './catalog-crud-modal.html',
})
export class CatalogCrudModalComponent {
  @Input({ required: true })
  modalId = '';

  @Input({ required: true })
  title = '';

  @Input({ required: true })
  submitLabel = '';

  @Input()
  showSubmit = true;

  @Input()
  cancelLabel = 'Cancel';

  @Input({ required: true })
  submitting = false;

  @Input()
  formError = '';

  @Input()
  widthClass = 'max-w-[520px]';

  @Output()
  submit = new EventEmitter<void>();

  @Output()
  cancel = new EventEmitter<void>();
}
